<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="年龄段分级病患占比表" name="second"></el-tab-pane>
      <el-tab-pane label="斑块阳性性别病患占比图" name="third"></el-tab-pane>
      <el-tab-pane label="斑块阳性分布病患线形图" name="fourth"></el-tab-pane>
    </el-tabs>
    <router-view @changeHospital="changeHospital" />
  </div>
</template>

<script>
import Global from "./Global";

export default {
  name: "PlaqueCount",
  data () {
    return {
      activeName: 'second',
      hospitalList: [],
      hospital: ''
    }
  },
  async mounted() {
    await this.getHospitalList()
    this.handleClick()
  },
  methods: {
    handleClick () {
      if (this.activeName === 'first') {
        this.$router.push({'name': 'plaqueCountOne'})
      }
      if (this.activeName === 'second') {
        this.$router.push({'name': 'plaqueCountTwo', params: {hospital: this.hospital, hospitals: this.hospitalList}})
      }
      if (this.activeName === 'third') {
        this.$router.push({'name': 'plaqueCountThree', params: {hospital: this.hospital, hospitals: this.hospitalList}})
      }
      if (this.activeName === 'fourth') {
        this.$router.push({'name': 'plaqueCountFour', params: {hospital: this.hospital, hospitals: this.hospitalList}})
      }
    },
    // 获取医院列表
    async getHospitalList() {
      let that = this
      let resp = await this.axios({
        method: 'GET',
        url: Global.yunyingUrl + '/service-hospital/hospital/getAllHospital'
      })
      if(resp.data.code === 1000) {
        that.hospitalList = resp.data.data
        that.hospital = that.hospitalList[5].hospitalId
      } else {
        this.$message.error(resp.data.msg)
      }
    },
    // 子组件重新选了医院
    changeHospital(value) {
      this.hospital = value
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PlaqueCount.vue